module.exports = __webpack_public_path__ + "static/media/cuh.e82e2a7c.jpg";